// extracted by mini-css-extract-plugin
export default {"card":"faq_card__e5Duj","icon":"faq_icon__dqwir"};